import { IdName } from '@api/models/idname';

export function mapEnumToOptions(translations: Record<string, string>): IdName[] {
  return Object.entries(translations).map(([key, name]) => ({
    id: +key,
    name,
  }));
}
